// extracted by mini-css-extract-plugin
export default {"tx":"ff1a33ee39","line":"_7175528669"};